import React, { useCallback, useEffect, useState } from "react";
import GizliIzle from "./GizliIzle";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Pager, Tabs, Chip, Modal, Person, img, fmt, when } from "./kit";
import { currentRole } from "../../Components/navbar/Sidebar";

const VoiceRooms = () => {
  const [dinlenen, setDinlenen] = useState(null);
  // Sabitleme gorunurlugu etkiler: yalnizca sahip (sunucu da ayrica denetler)
  const isOwner = currentRole() === "owner";
  const [status, setStatus] = useState("active");
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ rooms: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await api.voiceRooms({ status, q, page, size: 20 });
    if (res?.status) setData(res);
    setLoading(false);
  }, [status, q, page]);

  useEffect(() => {
    load();
  }, [load]);

  const open = async (r) => {
    const res = await api.voiceRoom(r._id);
    if (res?.status) setDetail(res);
  };

  const act = async (r, action, extra = {}) => {
    const needsReason = action === "close" || action === "ban";
    const reason = needsReason ? window.prompt(`"${r.title}" için sebep (işlem günlüğüne yazılır):`, "") : "";
    if (needsReason && reason === null) return;
    const res = await api.voiceRoomAction(r._id, { action, reason, ...extra });
    if (!res?.status) return window.alert(res?.message || "İşlem başarısız");
    setDetail(null);
    load();
  };

  // yonetim odasi: yalniz oda sahibi ve yazilan ID'ler girer, digerleri listede de gormez
  const restrict = (r) => {
    if (r.restricted) {
      const ids = window.prompt("Yönetim odası: girebilecek ID'ler (virgülle). Boş bırakıp Tamam = kısıtlamayı kaldır.", (r.allowIds || []).join(", "));
      if (ids === null) return;
      if (!ids.trim()) return act(r, "restrict", { on: false });
      return act(r, "restrict", { on: true, ids });
    }
    const ids = window.prompt(`"${r.title}" yönetim odası olsun. Oda sahibi dışında girebilecek ID'leri yaz (virgülle, örn. 1000, 2000):`, "");
    if (ids === null) return;
    act(r, "restrict", { on: true, ids });
  };

  const edit = async (r) => {
    const title = window.prompt("Oda adı", r.title);
    if (title === null) return;
    const notice = window.prompt("Oda bülteni (boş bırakılabilir)", r.notice || "");
    if (notice === null) return;
    act(r, "edit", { title, notice });
  };

  return (
    <>
      <PageHead title="Sesli Odalar" sub="Açık odaları izle, uygunsuz odayı kapat ya da kalıcı yasakla." />
      <Tiles
        items={[
          { label: "Listelenen", value: fmt(data.total) },
          { label: "Bu sayfada koltukta", value: fmt(data.rooms.reduce((t, r) => t + (r.occupied || 0), 0)) },
          { label: "Bu sayfada dinleyici", value: fmt(data.rooms.reduce((t, r) => t + (r.listenerCount || 0), 0)) },
          { label: "Toplanan hediye", value: fmt(data.rooms.reduce((t, r) => t + (r.totalGiftCoin || 0), 0)) },
        ]}
      />
      <div className="d-flex justify-content-between align-items-center" style={{ gap: 10, flexWrap: "wrap" }}>
        <Tabs
          value={status}
          onChange={(v) => {
            setStatus(v);
            setPage(1);
          }}
          tabs={[
            ["active", "Açık"],
            ["closed", "Kapalı"],
            ["banned", "Yasaklı"],
            ["video", "📹 Görüntülü"],
            ["game", "🎮 Oyun"],
            ["", "Tümü"],
          ]}
        />
        <input
          className="form-control"
          style={{ maxWidth: 260, marginBottom: 12 }}
          placeholder="Oda adı ara"
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            setPage(1);
          }}
        />
      </div>
      <Table
        loading={loading}
        head={["Oda", "Sahip", "Kategori", "Koltuk", "Dinleyici", "Hediye", "Durum", "İşlem"]}
        rows={data.rooms.map((r) => (
          <tr key={r._id}>
            <td>
              <Person image={r.coverImage || r.ownerImage} name={(r.pinOrder > 0 ? "📌 " : "") + (r.title || "—")} />
            </td>
            <td>{r.ownerName || "—"}</td>
            <td>{r.mode === "game" ? <Chip>🎮 Oyun odası</Chip> : r.mode === "video" ? <Chip>📹 Görüntülü parti</Chip> : r.category}</td>
            <td>
              {r.occupied}/{r.seatCount}
            </td>
            <td>{fmt(r.listenerCount)}</td>
            <td>{fmt(r.totalGiftCoin)}</td>
            <td>
              {r.isBanned ? <Chip kind="bad">Yasaklı</Chip> : r.isActive ? <Chip kind="live">Açık</Chip> : <Chip kind="wait">Kapalı</Chip>}
              {r.isLocked ? <span style={{ marginLeft: 6, whiteSpace: "nowrap" }} title="Oda şifresi">🔒 <b>{r.password}</b></span> : null}
              {r.restricted ? (
                <span style={{ marginLeft: 6 }} title={"Girebilenler: " + ((r.allowIds || []).join(", ") || "yalnız sahip")}>
                  <Chip kind="wait">🛡️ Yönetim</Chip>
                </span>
              ) : null}
            </td>
            <td style={{ whiteSpace: "nowrap" }}>
              <button className="btn btn-sm btn-outline-primary" onClick={() => open(r)}>
                Detay
              </button>{" "}
              {r.isActive && (
                <>
                  <button className="btn btn-sm btn-dark" onClick={() => setDinlenen(r)}>🎧 Gizli dinle</button>{" "}
                </>
              )}
              {isOwner && r.isActive && !r.isBanned && (
                <button
                  className={"btn btn-sm " + (r.pinOrder > 0 ? "btn-info" : "btn-outline-info")}
                  title={r.pinOrder > 0 ? "Sabitlemeyi kaldır" : "Uygulamada oda listesinin en üstüne sabitle"}
                  onClick={() => act(r, r.pinOrder > 0 ? "unpin" : "pin")}
                >
                  {r.pinOrder > 0 ? "📌 Sabitli" : "Sabitle"}
                </button>
              )}{" "}
              {r.isActive && (
                <button className="btn btn-sm btn-outline-secondary" onClick={() => edit(r)}>
                  Düzenle
                </button>
              )}{" "}
              {r.isActive && (
                <button className="btn btn-sm btn-warning" onClick={() => act(r, "close")}>
                  Kapat
                </button>
              )}{" "}
              {r.isBanned ? (
                <button className="btn btn-sm btn-outline-success" onClick={() => act(r, "unban")}>
                  Yasağı kaldır
                </button>
              ) : (
                <button className="btn btn-sm btn-danger badu-destructive" onClick={() => act(r, "ban")}>
                  Yasakla
                </button>
              )}
            </td>
          </tr>
        ))}
      />
      <Pager page={page} size={20} total={data.total} onChange={setPage} />

      <Modal open={!!detail} wide title={detail?.room?.title || "Oda"} onClose={() => setDetail(null)}>
        {detail && (
          <>
            {detail.room.coverImage ? (
              <img src={img(detail.room.coverImage)} alt="" style={{ width: "100%", maxHeight: 180, objectFit: "cover", borderRadius: 12, marginBottom: 12 }} />
            ) : null}
            <p style={{ fontSize: 13 }}>
              Sahip: <b>{detail.room.ownerName}</b> · Açılış: {when(detail.room.createdAt)} · Bülten: {detail.room.notice || "—"}
            </p>
            <div className="d-flex" style={{ gap: 8, marginBottom: 12 }}>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => act(detail.room, "resetSeats")}>
                Koltukları boşalt
              </button>
              {detail.room.isLocked && (
                <span style={{ alignSelf: "center" }}>
                  🔒 Oda şifresi: <b>{detail.room.password}</b>
                </span>
              )}
              {detail.room.isLocked && (
                <button className="btn btn-sm btn-outline-secondary" onClick={() => act(detail.room, "edit", { removePassword: true })}>
                  Şifreyi kaldır
                </button>
              )}
            </div>
            <h6>Koltuklar</h6>
            <div className="d-flex" style={{ flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
              {detail.seats.map((s) => (
                <div key={s._id} style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: "6px 10px", fontSize: 12, minWidth: 120 }}>
                  <b>#{s.seatIndex === 0 ? "Sahip" : s.seatIndex}</b> {s.userName || (s.isLocked ? "🔒 kilitli" : "boş")}
                  {s.isMuted ? " · susturulmuş" : ""}
                  <div style={{ color: "#6B7280" }}>{fmt(s.giftCoin)} coin</div>
                </div>
              ))}
            </div>
            <h6>Üyeler ({detail.members.length})</h6>
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Kişi</th>
                  <th>Rol</th>
                  <th>Harcama</th>
                  <th>Durum</th>
                </tr>
              </thead>
              <tbody>
                {detail.members.map((m) => (
                  <tr key={m._id}>
                    <td>
                      <Person image={m.userImage} name={m.userName} />
                    </td>
                    <td>{m.role === "owner" ? "Sahip" : m.role === "admin" ? "Yönetici" : "Dinleyici"}</td>
                    <td>{fmt(m.spentCoin)}</td>
                    <td>{m.isBanned ? <Chip kind="bad">Engelli</Chip> : m.present === false ? "Çıktı" : <Chip>İçeride</Chip>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {detail.bags.length > 0 && (
              <>
                <h6>Son şans çantaları</h6>
                <ul style={{ fontSize: 13 }}>
                  {detail.bags.map((b) => (
                    <li key={b._id}>
                      {b.senderName}: {fmt(b.totalCoin)} coin / {b.count} kişi — kalan {b.remainingCount} · {when(b.createdAt)}
                    </li>
                  ))}
                </ul>
              </>
            )}
          </>
        )}
      </Modal>
      {dinlenen && <GizliIzle oda stream={dinlenen} onClose={() => setDinlenen(null)} />}
    </>
  );
};

export default VoiceRooms;
